import { render, staticRenderFns } from "./UndoAddressRemove.vue?vue&type=template&id=031cdbd5&lang=pug"
import script from "./UndoAddressRemove.vue?vue&type=script&lang=js"
export * from "./UndoAddressRemove.vue?vue&type=script&lang=js"
import style0 from "./UndoAddressRemove.vue?vue&type=style&index=0&id=031cdbd5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports